/**
 * Download view - provides a download link for the AnnaCalendar desktop app.
 */

const DOWNLOAD_URL = 'https://anna-calendar-api.awesometools.workers.dev/download/AnnaCalendar.exe';

export function DownloadView() {
  return (
    <div className="h-full overflow-y-auto p-4 flex flex-col items-center justify-center">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="text-5xl">💻</div>
        <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>
          Get the Desktop App
        </h1>
        <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
          Download AnnaCalendar for Windows. The desktop app runs in the background,
          sends reminder notifications, and syncs with this phone automatically.
        </p>

        <a
          href={DOWNLOAD_URL}
          download
          className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold text-white transition-colors"
          style={{ backgroundColor: 'var(--accent-color, #6366f1)' }}
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          Download AnnaCalendar.exe
        </a>

        <p className="text-xs" style={{ color: 'var(--text-secondary)' }}>
          ~75 MB &middot; Windows 10/11 &middot; No installation needed
        </p>

        <div className="text-left space-y-3 pt-4 border-t" style={{ borderColor: 'var(--border-color, #333)' }}>
          <h2 className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>
            Setup instructions:
          </h2>
          <ol className="text-sm space-y-2 list-decimal list-inside" style={{ color: 'var(--text-secondary)' }}>
            <li>Download the file above</li>
            <li>Double-click to run (no installer needed)</li>
            <li>Enter the same passphrase you use here</li>
            <li>Everything syncs automatically</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
